import CategoriesDashboardAdmin from "./CategoriesDashboardAdmin";
export default CategoriesDashboardAdmin;
